import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiPost, ApiError } from "../api/client";

interface ChangeSecurityQPayload {
  current_password: string;
  new_security_question_code: string;
}

interface ChangeResponse {
  ok: boolean;
  code: string;
}

export function useChangeSecurityQ() {
  const qc = useQueryClient();
  return useMutation<ChangeResponse, ApiError, ChangeSecurityQPayload>({
    mutationFn: (p) => apiPost<ChangeResponse>("/api/auth/pm/change-security-q", p),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["pm-session"] }),
  });
}
